import { render } from "./Home.vue?vue&type=template&id=8967f3d0&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=8967f3d0&scoped=true&lang=css"

import exportComponent from "/home/grimos10/gits/grimos10.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8967f3d0"]])

export default __exports__